import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";

const HeaderSochial = () => {
  return (
    <div className="header__sochials">
      <a
        href="https://www.linkedin.com/in/abubakar-mahboob/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <BsLinkedin />
      </a>
      <a
        href="https://github.com/AbubakarChaudhary"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaGithub />
      </a>
      <a
        href="https://instagram.com/ab_tech_solutions_?igshid=MzMyNGUyNmU2YQ=="
        target="_blank"
        rel="noopener noreferrer"
      >
        <GrInstagram />
      </a>
    </div>
  );
};

export default HeaderSochial;
